import React, { useState } from "react"
import CountUp from "react-countup"
import VisibilitySensor from "react-visibility-sensor"

const Ticker = ({ className, startNum, ...rest }) => {
  const [viewPortEntered, setViewPortEntered] = useState(false)

  return (
    <CountUp {...rest} start={viewPortEntered ? null : startNum} separator=" ">
      {({ countUpRef }) => {
        return (
          <VisibilitySensor
            active={!viewPortEntered}
            onChange={isVisible => {
              if (isVisible) {
                setViewPortEntered(true)
              }
            }}
            delayedCall
          >
            <span className={className} ref={countUpRef} />
          </VisibilitySensor>
        )
      }}
    </CountUp>
  )
}

export default Ticker
